const items = [
  "INDIAN · CHINESE · ITALIAN · THAI",
  "PRIVATE DINING ROOMS",
  "OPEN-AIR GARDEN LAWN",
  "BIRTHDAYS · ANNIVERSARIES · WEDDINGS",
  "VEG & NON-VEG",
  "BIG PRIVATE CAR PARKING",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div className="marquee" aria-label="Hashtag restaurant highlights" data-testid="editorial-marquee">
      <div className="marquee-track">
        {loop.map((item, index) => <span className="marquee-item" key={`${item}-${index}`}>{item}</span>)}
      </div>
    </div>
  );
}
